// src/components/pages/ExpertisePage.js
import React from 'react';
import { Box, Grid } from '@mui/material';
import { EXPERTISE_DATA } from '../../data/expertiseData';
import HeroBanner from '../common/HeroBanner';
import FeatureCard from '../common/FeatureCard';

const ExpertisePage = ({ pageId }) => {
  const content = EXPERTISE_DATA[pageId];

  if (!content) {
    return <Box sx={{ p: 4 }}>페이지를 찾을 수 없습니다.</Box>;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <HeroBanner image={content.heroImage} title={content.title} tagline={content.tagline} />

      <Box sx={{ p: { xs: 3, md: 5 } }}>
        <Grid container spacing={3}>
          {content.categories.map((category, index) => (
            <Grid item xs={12} md={4} key={index}>
              <FeatureCard
                image={category.image}
                title={category.title}
                description={category.description}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ExpertisePage;
